<template>
  <div>
    <div
      v-if="question.image"
      class="flex justify-center items-end rounded-lg overflow-hidden bg-surface-brand-low"
    >
      <RevIllustration
        alt=""
        :height="372"
        :src="question.image"
        :width="492"
      />
    </div>
    <div
      class="flex p-24 flex-col gap-20 bg-surface-default-low rounded-t-lg overflow-hidden items-center md:bg-transparent"
    >
      <h3 v-if="question.title" class="heading-2">{{ question.title }}</h3>
      <p v-if="question.info.text" class="label-large">
        {{ question.info.text.join(' ') }}
      </p>
      <RevButton
        :data-qa="question.key"
        fullWidth="always"
        variant="primary"
        @click="emit('answer', question.key, question.value as string)"
      >
        {{ i18n(translations.continue) }}
      </RevButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevIllustration } from '@ds/components/Illustration'

import type { RenderQuestion } from '~/scopes/buyback/composables/useFunnelQuestions'

import translations from './FunctionalInformation.translations'

defineProps<{
  question: RenderQuestion
}>()

const emit = defineEmits<{
  (event: 'answer', key: string, value: string): void
}>()

const i18n = useI18n()
</script>
